module.exports = __webpack_public_path__ + "img/logo-fortiorfysiotherapie.de7505f8.png";